
    import './styles.scoped.css';
    export default {
  "root": "awsui_root_1dx2b_1h1xd_9",
  "action-slot": "awsui_action-slot_1dx2b_1h1xd_41",
  "group-layout": "awsui_group-layout_1dx2b_1h1xd_46",
  "group-layout-horizontal": "awsui_group-layout-horizontal_1dx2b_1h1xd_50",
  "group-layout-vertical": "awsui_group-layout-vertical_1dx2b_1h1xd_53",
  "controls": "awsui_controls_1dx2b_1h1xd_57",
  "controls-horizontal": "awsui_controls-horizontal_1dx2b_1h1xd_61",
  "controls-vertical": "awsui_controls-vertical_1dx2b_1h1xd_65",
  "control": "awsui_control_1dx2b_1h1xd_57",
  "control-middle-horizontal": "awsui_control-middle-horizontal_1dx2b_1h1xd_73",
  "control-last-horizontal": "awsui_control-last-horizontal_1dx2b_1h1xd_73",
  "control-middle-vertical": "awsui_control-middle-vertical_1dx2b_1h1xd_76",
  "control-last-vertical": "awsui_control-last-vertical_1dx2b_1h1xd_76",
  "inline-label": "awsui_inline-label_1dx2b_1h1xd_85",
  "inline-label-wrapper": "awsui_inline-label-wrapper_1dx2b_1h1xd_110",
  "inline-label-trigger-wrapper": "awsui_inline-label-trigger-wrapper_1dx2b_1h1xd_115"
};
  